import { isString } from "validate.js";
const isNullOrUndefined = (value) => {
    // nullとundefinedはまとめてnull判定
    // eslint-disable-next-line no-undefined
    if (value === null || value === undefined) {
        return true;
    }
    // 0は!valueで判定するとtrueの方に落ちるんで別個判定する
    if (value === 0) {
        return false;
    }
    return !value;
};
const MypageMessageFormat = (str, vals) => {
    if (!isString(str)) {
        return str;
    }
    let reg = /(%?)%\{([^}]+)\}/g;
    return str.replace(reg, (m0, m1, m2) => {
        if (m1 === "%") {
            return "%{" + m2 + "}";
        }
        return String(vals[m2]);
    });
};
export { isNullOrUndefined, MypageMessageFormat };
